module.exports = __webpack_public_path__ + "img/05-28-168.4259a079.jpg";